import { useEffect, useRef } from 'react';
import { useAppSelector } from '../../store/reduxHooks';
import { toast } from 'react-toastify';
import { CustomToastContent } from '../CustomToastContent/CustomToastContent';

export const TechnicalErrorToastListener: React.FC = () => {
  const errors = useAppSelector((state) => state.technicalError.errors);
  const isErrorModal = useAppSelector(
    (state) => state.technicalError.isErrorModal
  );
  const lastErrorIdRef = useRef<number | null>(null);

  useEffect(() => {
    if (
      errors.length > 0 &&
      errors[errors.length - 1].id !== lastErrorIdRef.current &&
      errors[errors.length - 1].suppressToast !== true
    ) {
      const error = errors[errors.length - 1];
      toast(
        <CustomToastContent
          message={error.message}
          endpoint={error.request.url ?? ''}
          params={
            typeof error.request.params === 'object' &&
            error.request.params !== null
              ? (error.request.params as Record<
                  string,
                  string | number | boolean | undefined
                >)
              : undefined
          }
          responseData={error.response.data}
          meta={error.response.meta}
          status={error.response.status}
        />,
        { type: 'error' }
      );
      lastErrorIdRef.current = error.id;
    }
  }, [errors, isErrorModal]);

  return null;
};
